import {
   dateShortWeekdayFormatter,
   hourMinuteFormatter,
   Translate,
   useInterpolatedTranslationKey,
} from '@dreryk/react-common';

import { visitDetailsTranslationKeys } from '../../../translations';

import { StyledPreInterviewApprovalDateText } from './PreInterviewApprovalDateText.styled';

type PreInterviewApprovalDateTextProps = { readonly approvalDate: Date };

export const PreInterviewApprovalDateText = (props: PreInterviewApprovalDateTextProps): JSX.Element => {
   return (
      <StyledPreInterviewApprovalDateText testId={'preInterviewApprovalDateText'}>
         <Translate>
            {useInterpolatedTranslationKey(visitDetailsTranslationKeys.preInterview.dialog.approvalDateText, {
               date: dateShortWeekdayFormatter(props.approvalDate),
               time: hourMinuteFormatter(props.approvalDate),
            })}
         </Translate>
      </StyledPreInterviewApprovalDateText>
   );
};
